import { ClockIcon, TagIcon, UserIcon } from "@phosphor-icons/react";
import { Ref, RefObject } from "react";

interface FormHeaderProps {
	formType: string;
	icon?: string;
	title: string;
	description?: string;
	headingRef: Ref<HTMLHeadingElement>;
}

export function FormHeader({ icon, title, description, headingRef, formType }: FormHeaderProps) {
	if (formType === "consultation") {
		return (
			<div className="yF-flex yF-flex-row yF-gap-2 yF-items-center">
				<div
					ref={headingRef}
					className="yF-w-12 yF-h-12 yF-flex yF-items-center yF-justify-center yF-rounded-lg yF-bg-[--yF-theme-color]"
				>
					{icon === "clock" && (
						<ClockIcon
							className="yF-p-1 yF-h-10 yF-w-10 yF-text-white"
							aria-hidden="true"
						/>
					)}
					{icon === "tag" && (
						<TagIcon
							className="yF-p-1 yF-h-10 yF-w-10 yF-text-white"
							aria-hidden="true"
						/>
					)}
					{icon === "user" && (
						<UserIcon
							className="yF-p-1 yF-h-10 yF-w-10 yF-text-white"
							aria-hidden="true"
						/>
					)}
				</div>
				<div className="yF-flex yF-flex-col">
					<h2 className="yF-text-lg yF-font-bold yF-mb-0">{title}</h2>
					<p className="yF-text-sm yF-text-gray-500">{description}</p>
				</div>
			</div>
		);
	} else if (formType === "quickForm") {
		return (
			<>
				<div className="yF-text-pretty yF-text-center">
					<h2
						ref={headingRef}
						className="yF-text-[2.2rem] yF-mb-3 yF-font-semibold yF-leading-8 yF-text-[--yF-theme-h-text]"
					>
						{title}
					</h2>
					<div className="yF-mt-2">
						<p className="yF-text-md yF-text-gray-500">
							This will not affect your credit score
						</p>
					</div>
				</div>
			</>
		);
	}
}
